//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { NsIcon, NsAnimateHeight } from "@nuskin/design-components";
import NsImage from "./NsImage.vue";
import NsProductCardAction from "./NsProductCardAction.vue";
import NsProductPrice from "./NsProductPrice.vue";
import NsProductSkuPoints from "./NsProductSkuPoints.vue";
import NsProductVariantSelector from "./NsProductVariantSelector.vue";

/**
 * NsProductCardBase
 *
 * How to use: You shouldn't use this component. Use NsProductCard instead. It
 * includes the Product mixin. This component is simply all the html and styles.
 *
 * @event variant-select  When a variant selection occurs, this event emits a
 * function with params: (value, index)
 * @event quantity-select  When a quantity selection occurs, this event emits a
 * function with params: (value, index)
 * @event add-to-cart  When clicking on "Add to Cart", this event emits a
 * function with params: ()
 * @event add-to-adr  When clicking on "Add to Adr", this event emits a function
 * with params: ()
 * @event card-click  When clicking on the ProductCard, this event emits a
 * function with params: (product). If listener is NOT assigned, clicking the
 * card will go to the product detail page
 * @event favorite-click  When clicking on the favorite icon, this event emits a
 * function with params: ()
 */

export default {
  name: "NsProductCardBase",
  components: {
    NsIcon,
    NsImage,
    NsProductPrice,
    NsProductCardAction,
    NsAnimateHeight,
    NsProductSkuPoints,
    NsProductVariantSelector
  },
  props: {
    /**
     * ADR price value
     */
    adrPrice: {
      type: String,
      default: ""
    },
    adrPriceType: {
      type: String,
      default: ""
    },
    disableAddToAdr: Boolean,
    disableAddToCart: Boolean,
    disableQuantitySelector: Boolean,
    exclusiveOfferMessage: {
      type: String,
      default: ""
    },
    forcesv: Boolean,
    hideExclusiveIcon: Boolean,
    hideExclusiveTextOnMobile: Boolean,
    hideFavorites: Boolean,
    hideSku: Boolean,
    // TODO: src/alt/fallbackSrc props to image prop
    imageFallbackSrc: {
      type: String,
      default: ""
    },
    image: {
      type: Object,
      default() {
        return {};
      }
    },
    imageSet: {
      type: Array,
      default() {
        return [];
      }
    },
    isBaseSku: Boolean,
    isDistributor: Boolean,
    isExclusive: Boolean,
    isFavorite: Boolean,
    isLoggedIn: Boolean,
    isLoyaltyEnabled: Boolean,
    isSale: Boolean,
    loyaltyStatusAndLinks: {
      type: Object,
      default() {
        return {};
      }
    },
    marketAttributes: {
      type: Object,
      default() {
        return {};
      }
    },
    maxQuantity: {
      type: Number,
      default: null
    },
    maxPrice: {
      type: String,
      default: ""
    },
    minPrice: {
      type: String,
      default: ""
    },
    /**
     * Determines if the product card should have the small-width styling to support side-by-side in mobile
     */
    mobileSideBySide: Boolean,
    noAction: Boolean,
    originalPrice: {
      type: String,
      default: ""
    },
    originalPriceLabel: {
      type: String,
      default: ""
    },
    originalPriceType: {
      type: String,
      default: ""
    },
    points: {
      type: String,
      default: null
    },
    price: {
      type: Number,
      default: null
    },
    priceLabel: {
      type: String,
      default: ""
    },
    priceType: {
      type: String,
      default: ""
    },
    quantity: {
      type: String,
      default: "1"
    },
    salesLabel: {
      type: String,
      default: ""
    },
    /**
     * This prop is only for storybook for simple dev use
     */
    showAction: Boolean,
    showAdrPrice: Boolean,
    showAdrOnly: Boolean,
    showExclusiveOfferMessage: Boolean,
    showOriginalCrossedOut: Boolean,
    showPriceLabels: Boolean,
    showVariantSelector: Boolean,
    sku: {
      type: String,
      default: ""
    },
    /**
     * Warning message, if product is out of stock or whatever
     */
    statusMessage: {
      type: String,
      default: ""
    },
    /**
     * Warning message key, for qa testing automation
     */
    statusMessageKey: {
      type: String,
      default: ""
    },
    title: {
      type: String,
      default: ""
    },
    translations: {
      type: Object,
      default() {
        return {};
      }
    },
    userIsQualified: Boolean,
    userLoyalty: {
      type: Object,
      default() {
        return {};
      }
    },
    variantSkus: {
      type: Array,
      default() {
        return [];
      }
    },
    variants: {
      type: Array,
      default() {
        return [];
      }
    }
  },
  data() {
    return {
      actionOpened: false,
      initSku: null,
      product: null,
      variantIndex: null
    };
  },
  computed: {
    isTouchLikeDevice() {
      return (
        this.isMobileDevice() || this.$mq === "mobile" || this.$mq === "phablet"
      );
    },
    showPrices() {
      return (
        ((this.price && this.price !== "0") ||
          (this.minPrice && this.minPrice !== "0")) &&
        !(this.isExclusive && !this.userIsQualified && !this.noAction)
      );
    },
    showSkuPrices() {
      return !this.isBaseSku && (!this.noAction || this.forcesv);
    },
    showExclusiveOfferLabel() {
      return !(this.hideExclusiveTextOnMobile || this.useMobileSideBySide);
    },
    useMobileSideBySide() {
      return (
        (this.$mq === "mobile" || this.$mq === "phablet") &&
        this.mobileSideBySide
      );
    }
  },
  methods: {
    closeAction() {
      this.actionOpened = false;
    },
    handleQuantitySelect(value, index) {
      /**
       * Fired when a new quantity is selected: function(value: string|number,
       * index: number) => void
       *
       * @type {select}
       * @property {(string|number)} value data-value attribute of the selected
       * item, or index
       * @property {number} index index of the selected item
       */
      this.$emit("quantity-select", value, index);
    },
    handleAddToCart(event) {
      /**
       * Fired when "add to cart" button is clicked: function(event) => void
       *
       * @type {click}
       * @property {event} event the click event
       */
      this.$emit("add-to-cart", event);
    },
    handleAddToAdr(event) {
      /**
       * Fired when "add to cart" button is clicked: function(event) => void
       *
       * @type {click}
       * @property {event} event the click event
       */
      this.$emit("add-to-adr", event);
    },
    handleSelectVariant(selected, index) {
      /**
       * Fired when a new variant is selected: function(value: string|number,
       * index: number) => void
       *
       * @type {select}
       * @property {(string|number)} value data-value attribute of the selected
       * item, or index
       * @property {number} index index of the selected item
       */
      this.$emit("variant-select", selected, index);
    },
    /**
     * Checks if device is mobile (will use modal if so)
     */
    isMobileDevice() {
      return (
        typeof window.orientation !== "undefined" ||
        navigator.userAgent.includes("IEMobile")
      );
    },
    handleCardClick() {
      this.$emit("card-click");
    },
    handleFavoriteClick() {
      this.$emit("favorite-click");
    },
    openAction() {
      this.actionOpened = true;
    }
  }
};
